__turbopack_context__.v({
  "separator": "Timeline-module__6Nll8q__separator",
  "step": "Timeline-module__6Nll8q__step",
  "stepBody": "Timeline-module__6Nll8q__stepBody",
  "stepIcon": "Timeline-module__6Nll8q__stepIcon",
  "stepLabel": "Timeline-module__6Nll8q__stepLabel",
  "stepper": "Timeline-module__6Nll8q__stepper",
  "steps": "Timeline-module__6Nll8q__steps",
});
